module.exports = __webpack_public_path__ + "static/media/71.94d796b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/71.jpg
// module id = 630
// module chunks = 0